import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@vds-core/utilities';
import { AccessibilityTokens } from '@vds-tokens/accessibility';
var propTypes = {
  /**
   * @ignore
   */
  size: PropTypes.oneOf(['medium', 'small']),
  /**
   * @ignore
   */
  showDialog: PropTypes.bool,
  /**
   * @ignore
   */
  hovered: PropTypes.bool,
  /**
   * @ignore
   */
  activeStyleState: PropTypes.bool
};
var defaultProps = {
  showDialog: false,
  hovered: false,
  activeStyleState: false
};
var AnchorIconBase = /*#__PURE__*/styled.button.withConfig({
  displayName: "AnchorIconBase",
  componentId: "VDS__sc-1liec79-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  background: none;\n  color: inherit;\n  cursor: ", ";\n  transition-delay: 0.2s;\n  overflow: visible;\n  left: ", ";\n  position: relative;\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n  svg {\n    -webkit-transform: translate(0px, 0px);\n  }\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'default' : 'pointer';
}, calculateRem(4), function (_ref2) {
  var keyboardFocused = _ref2.keyboardFocused;
  return !keyboardFocused && "\n    outline: none;\n\n  ";
}, function (_ref3) {
  var keyboardFocused = _ref3.keyboardFocused,
    surface = _ref3.surface,
    size = _ref3.size,
    mobile = _ref3.mobile,
    hovered = _ref3.hovered;
  return keyboardFocused && !mobile && !hovered && "\n    outline: none;\n    &:focus {\n        &::before {\n          border: ".concat(calculateRem(AccessibilityTokens.focusring.borderwidth.value), " ").concat(AccessibilityTokens.focusring.borderstyle.value, " ").concat(surface === 'dark' ? AccessibilityTokens.color.focusring.ondark.value : AccessibilityTokens.color.focusring.onlight.value, ";\n          border-radius: 50%;\n          content: '';\n          height: calc(100% - ").concat(size === 'small' ? 2 : 2, "px);\n          left: 50%; \n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% - ").concat(size === 'small' ? 2 : 2, "px);\n        }\n    }\n  ");
}, function (_ref4) {
  var keyboardFocused = _ref4.keyboardFocused,
    surface = _ref4.surface,
    size = _ref4.size,
    showDialog = _ref4.showDialog,
    mobile = _ref4.mobile,
    hovered = _ref4.hovered;
  return keyboardFocused && showDialog && !mobile && !hovered && "\n    outline: none;\n        &::before {\n          border: ".concat(calculateRem(AccessibilityTokens.focusring.borderwidth.value), " ").concat(AccessibilityTokens.focusring.borderstyle.value, " ").concat(surface === 'dark' ? AccessibilityTokens.color.focusring.ondark.value : AccessibilityTokens.color.focusring.onlight.value, ";\n          border-radius: 50%;\n          content: '';\n          height: calc(100% - ").concat(size === 'small' ? 2 : 2, "px);\n          left: 50%; \n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% - ").concat(size === 'small' ? 2 : 2, "px);\n        }\n    \n  ");
}, function (_ref5) {
  var hovered = _ref5.hovered,
    surface = _ref5.surface;
  return hovered && surface === 'light' && " \n       &:focus,\n       &.focus-visible {\n        outline: none;\n        &::after {\n          border: none;\n          outline: none;\n        }\n      }\n    ";
});
AnchorIconBase.propTypes = propTypes;
AnchorIconBase.defaultProps = defaultProps;
export default AnchorIconBase;